import React from "react";
import UrlToLinks from "./UrlToLinks.jsx";
import CitationLinks from "./CitationLinks.jsx";

const TextWithDistributedCitations = ({ text, references, id, keyPrefix }) => {
  const sentences = text.split(/([.!?]\s+)/);
  const totalSentences = Math.ceil(sentences.length / 2);
  
  const referencesPerSentence = Math.ceil(references.length / Math.max(totalSentences, 1));
  let currentRefIndex = 0;
  
  return (
    <>
      {sentences.map((sentence, index) => {
        const isPunctuation = /^[.!?]\s*$/.test(sentence);
        const sentenceIndex = Math.floor(index / 2);
        const shouldShowRefs = !isPunctuation && 
                               sentenceIndex > 0 && 
                               sentenceIndex % referencesPerSentence === 0 &&
                               currentRefIndex < references.length;
        
        let refsToShow = [];
        if (shouldShowRefs) {
          const refsCount = Math.min(referencesPerSentence, references.length - currentRefIndex);
          refsToShow = Array.from({ length: refsCount }, (_, i) => ({
            referenceIndex: currentRefIndex + i
          }));
          currentRefIndex += refsCount;
        }
        
        return (
          <React.Fragment key={`${keyPrefix}-sentence-${index}`}>
            <UrlToLinks text={sentence} keyPrefix={`${keyPrefix}-${index}`} />
            {shouldShowRefs && refsToShow.length > 0 && (
              <span className="ai-overview__citation">
                <CitationLinks
                  sources={refsToShow}
                  references={references}
                  id={id}
                  citationIndex={`sentence-${sentenceIndex}`}
                />
              </span>
            )}
          </React.Fragment>
        );
      })}
      {currentRefIndex < references.length && (
        <span className="ai-overview__citation">
          <CitationLinks
            sources={Array.from(
              { length: references.length - currentRefIndex }, 
              (_, i) => ({ referenceIndex: currentRefIndex + i })
            )}
            references={references}
            id={id}
            citationIndex="end"
          />
        </span>
      )}
    </>
  );
};

export default TextWithDistributedCitations;

